import React from "react";
import {TextFieldAddOnProps} from "peggirkit/dist/components/Input/Field/TextField/TextFieldAddOn/TextFieldAddOn";
import ButtonAddOn from "peggirkit/dist/components/Input/Field/TextField/TextFieldAddOn/ButtonAddOn";
import {Icon, NotifyFn} from "peggirkit";
import {DocumentDuplicateIcon} from "@heroicons/react/16/solid";
import {IntlShape} from "react-intl";
import {notifySuccess} from "@/utils/NotifyUtils";
import {ApplyTooltipFn} from "@widgets/tooltip/TooltipProvider";

type TrailingCopyButtonProps = {
    copyTxt: string,
    applyTooltip: ApplyTooltipFn,
    intl: IntlShape,
    notify: NotifyFn,
};

const TrailingCopyButton = ({copyTxt, applyTooltip, intl, notify}: TrailingCopyButtonProps): TextFieldAddOnProps => {
    return ButtonAddOn({
        position: "trailing",
        buttonProps: {
            iconAfter: (
                <Icon
                    className={"opacity-70"}
                    icon={DocumentDuplicateIcon}
                />
            ),
            iconOnly: true,
            props: {
                type: "button",
                ...applyTooltip(intl.formatMessage({id: "copy"})),
            },
            buttonAction: {
                as: "button",
                actionProps: {
                    onClick: e => {
                        e.preventDefault();
                        navigator
                            .clipboard
                            .writeText(copyTxt)
                            .then(() => {
                                notifySuccess(intl.formatMessage({id: "copied"}), notify);
                            });
                    }
                },
            },
        },
    })
};

export default TrailingCopyButton;